/* Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { theme } from "@nordcloud/gnui";

export const SearchWrapper = styled.div`
  margin: 0 ${theme.spacing.spacing05};
  flex-grow: 1;
`;

export const FiltersWrapper = styled.div`
  margin-top: ${theme.spacing.spacing04};
  margin-left: ${theme.spacing.spacing02};
`;
